export const environment = {
  production: false,
  serverUrl: 'https://api-stage.zoodlekid.co.in',
};
